import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ArrowRight, X } from "react-feather";
import { formatNextStepCopy, getActionRoute, IDEA_CHIP_TEMPLATES } from "./nextStepCopy";
import { recordGuidanceInteraction } from "@src/redux/actions/brandsDashboard";

const NextStepCard = ({ step, stepNumber, isHero }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isDismissed, setIsDismissed] = useState(false);

  const formatted = formatNextStepCopy(step);

  // Guide Section 5: Send `shown` once when incomplete_profile is rendered to start 7-day cap
  useEffect(() => {
    if (
      (formatted?.type === "incomplete_profile" ||
        formatted?.type === "profile_completion") &&
      formatted?.id
    ) {
      dispatch(
        recordGuidanceInteraction({
          card_id: formatted.id,
          event: "shown"
        })
      );
    }
  }, [formatted?.id, formatted?.type]);

  if (!formatted || isDismissed) return null;

  const handleAction = () => {
    if (formatted.id) {
      dispatch(
        recordGuidanceInteraction({
          card_id: formatted.id,
          event: "opened"
        })
      );
    }
    if (formatted.action?.type === "open_messages" && formatted.action?.rd_id) {
      try {
        if (formatted.action.user) {
          localStorage.setItem("selectedChatRd", JSON.stringify(formatted.action.user));
        } else {
          const stored = localStorage.getItem("selectedChatRd");
          if (stored) {
            const parsed = JSON.parse(stored);
            if (parsed?.id && parseInt(parsed.id) !== parseInt(formatted.action.rd_id)) {
              localStorage.removeItem("selectedChatRd");
            }
          }
        }
      } catch (e) { }
    }
    const route = getActionRoute(formatted.action);
    history.push(route);
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    setIsDismissed(true);
    if (formatted.id) {
      dispatch(
        recordGuidanceInteraction({
          card_id: formatted.id,
          event: "dismissed"
        })
      );
    }
  };

  const isHeroCard = Boolean(isHero || formatted.is_hero || stepNumber === 1);
  const isDismissible = Boolean(step?.dismissible === true);

  const isNoActivePosts = Boolean(
    formatted?.type === "no_active_posts" ||
    step?.type === "no_active_posts"
  );
  const templates = formatted?.templates || (isNoActivePosts ? IDEA_CHIP_TEMPLATES : null);

  return (
    <div
      className={`figma-next-step-card ${isHeroCard ? "is-hero" : ""}`}
      id={`next-step-card-${stepNumber}`}
    >
      {isDismissible && (
        <button
          type="button"
          className="btn btn-link p-0 position-absolute"
          style={{ top: "12px", right: "12px", color: "#6e6b7b", zIndex: 2 }}
          onClick={handleDismiss}
          aria-label="Dismiss card"
          title="Dismiss"
        >
          <X size={16} />
        </button>
      )}

      <div className="card-content-top">
        <div className={`step-badge-circle ${isHeroCard ? "hero-badge" : "default-badge"}`}>
          {stepNumber}
        </div>

        <h4 className="card-headline">{formatted.title}</h4>
        <p className="card-description">{formatted.description}</p>

        {/* ─── Four Required Outreach Ideas / Templates (Section 3.4) ─── */}
        {isNoActivePosts && templates && templates.length > 0 && (
          <div className="outreach-templates-chips" id="outreach-templates-chips">
            <span className="templates-label">Outreach Ideas:</span>
            <div className="templates-chip-group">
              {templates.map((template) => (
                <button
                  type="button"
                  key={template.id}
                  className="template-chip-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    history.push(template.route);
                  }}
                >
                  {template.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="card-content-footer">
        {isHeroCard ? (
          <button
            type="button"
            className="hero-cta-btn"
            onClick={handleAction}
          >
            {formatted.ctaLabel || "Review applicants"}
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-link p-0 regular-cta-link"
            onClick={handleAction}
          >
            <span className="cta-label-text">{formatted.ctaLabel}</span>
            <ArrowRight size={14} className="ml-50 cta-arrow-icon" />
          </button>
        )}

        {formatted.timeEstimate && (
          <span className="time-estimate-text">{formatted.timeEstimate}</span>
        )}
      </div>
    </div>
  );
};

NextStepCard.propTypes = {
  step: PropTypes.object.isRequired,
  stepNumber: PropTypes.number.isRequired,
  isHero: PropTypes.bool
};

export default NextStepCard;

